import Vue from "vue"
import store from "./store"
import router from "./router"
import App from "./App.vue"
/**
 * Plugins
 */
import "./bootstrap.js"
/**
 * Helpers
 */
import helperAuth from "./mixins/helperAuth"
import helperGlobals from "./mixins/helperGlobals"
import helperLanguage from "@/mixins/helperLanguage"

Vue.config.productionTip = false

router.afterEach((to, from) => {
  document.title = to.meta.title || "MTD BIO | Kadro"
})

new Vue({
  mixins: [helperAuth, helperGlobals, helperLanguage],
  router,
  store,
  data () {
    return {
      appPath: process.env.VUE_APP_URL,
      appStorage: process.env.VUE_APP_URL + "storage",
      uik: {
        datepicker: {
          valueFormat: "YYYY-MM-DD HH:mm:ss"
        }
      }
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters["auth/isAdmin"]
    }
  },
  methods: {
    // TODO: Ideally move this into Auth resource
    userHasPermission (permission) {
      if (!permission) return false

      let permissions = Array.isArray(permission) ? permission : [permission]
      const userPermissions = this.$store.state.auth.user.permissions
      if (!userPermissions) return false

      for (let i = 0; i < permissions.length; i++) {
        if (!userPermissions.find(item => item === permissions[i])) return false
      }
      return true
    }
  },

  render: h => h(App)
}).$mount("#app")
